<template>
  <div class="header">
    <div class='header-content'>
      <div class='header-left'>
      </div>
      <div class='header-center'><span>{{name}}</span></div>
      <div class='header-right'>
        <span v-if="isSetting" class='header-right iconfont icon-set right' @click='handleClickIcon'></span>
        <span v-if="isDelete" class='header-right delete' @click='handleClickIcon'>删除</span>
        <template slot='right'></template>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'head-nav',
  props: {
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    goBack: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
    };
  },
  computed: {
    isSetting () {
      if (this.type === 'setting') {
        return true
      }
    },
    isDelete () {
      if (this.type === 'delete') {
        return true
      }
    }
  },
  methods: {
    handleClickIcon () {
      this.$emit('click-icon')
    },
    handleGoback () {
      this.$emit('click-back')
      this.$router.back()
    }
  },
}
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  min-width: 320px;
  max-width: 750px;
  width: 100%;
  z-index: 2;
  .header-content {
    background-color: #269cca;
    text-align: center;
    height: 100px;
    width: 100%;
    color: #fff;
    font-size: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    .header-left {
      width: 20%;
      padding-left: 20px;
      text-align: left;
      display: flex;
      align-items: center;
    }
    .header-center {
      width: 60%;
    }
    .header-right {
      width: 20%;
      .delete {
        font-size: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/member/head-nav/index.vue